<template>
  <nav class="blog-filters" aria-label="Navegação editorial do blog">
    <div class="blog-filters__categories">
      <router-link
        :to="filterLink(null)"
        class="blog-filters__chip"
        :class="{ 'blog-filters__chip--active': !activeCategory }"
        :aria-current="!activeCategory ? 'page' : null"
      >
        Todas
      </router-link>
      <router-link
        v-for="category in categories"
        :key="category.slug"
        :to="filterLink(category.slug)"
        class="blog-filters__chip"
        :class="{ 'blog-filters__chip--active': activeCategory === category.slug }"
        :aria-current="activeCategory === category.slug ? 'page' : null"
      >
        {{ category.name }}
      </router-link>
    </div>
  </nav>
</template>

<script>
export default {
  name: "BlogFilters",
  props: {
    categories: { type: Array, default: () => [] },
    activeCategory: { type: String, default: "" },
  },
  methods: {
    filterLink(slug) {
      const query = { ...this.$route.query };
      if (slug) query.categoria = slug;
      else delete query.categoria;
      return { path: "/portal-zinnes", query };
    },
  },
};
</script>
